<template>
  <table class="table" :class="tableClass">
    <thead class="thead-dark">
      <th style="cursor: pointer;" @click="onClickformScenarioNameColumnHeader">
        {{ this.$t("__Conversationname") }} {{ getSortOrderLabel(formScenarioNameColumnSortState) }}
      </th>
      <th>{{ this.$t("__Triggerpoint") }}</th>
      <th v-if="accountType == 'line'">User Icon</th>
      <th>{{ this.$t("__Numberofnodes") }}</th>
      <th>{{ this.$t("__Editdateandtime") }}</th>
      <th></th>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td>{{ item.formscenario.formScenarioName }}</td>
          <td v-html="triggerValue(item.formscenario.trigger)"
            @click="showKeyords(item.formscenario.trigger, item.formscenario.keywords)"
            :class="{ pointer: (item.formscenario.trigger == 'keyword') }"></td>
          <td v-if="accountType == 'line'">
            <select v-model="item.formscenario.iconUrlId" @change="onUserIconChanged(item)">
              <option value selected>
                {{ $t("__UserIconSelectOptional") }}
              </option>
              <option :value="userIcon.id" v-for="(userIcon, index) in userIconList" :key="index">
                {{ userIcon.name }}
              </option>
            </select>
          </td>
          <td>{{ item.nodes.length }}</td>
          <td>{{ toFrontendTimeFormat(item.updateTime) }}</td>
          <td>
            <a href="javascript:void(0)" class="editStoryIcon" @click="editStory(item)">
              <i class="fas fa-edit mx-1"></i>
            </a>
            <router-link :to="{
              name: (item.formscenario.trigger === 'formFilter') ? 'formFilter' : 'formNodes',
              params: {
                id: item.formscenario.formScenarioId,
                adminId: adminId,
                jwtToken: jwtToken,
                accountId: accountId,
              },
            }">
              <i class="fas fa-comment-dots mx-1"></i>
            </router-link>
            <a href="javascript:void(0)" @click="copyFormScenario(item)">
              <i class="fas fa-copy mx-1"></i>
            </a>
            <a href="javascript:void(0)" @click="deleteFormScenario(item.formscenario.formScenarioId)">
              <i class="fas fa-trash text-danger mx-1"></i>
            </a>
          </td>
        </slot>
      </tr>
    </tbody>
    <create-edit-form-story-modal :adminId="adminId" :jwtToken="jwtToken" :accountId="accountId" :allScenario="allScenario"
      v-bind:modalData="modalData" v-bind:existTrigger="trigger" :editId="editId" :key="componentKey"
      v-if="componentKey"></create-edit-form-story-modal>
    <!-- add new story icon-->
    <div class="btn-follow">
      <a href="javascript:void(0)" v-on:click="createStory()" style="color: #fff">
        <i class="fas fa-plus"></i>
      </a>
    </div>
    <!-- add new story icon-->
  </table>
</template>
<script>
import { Utility } from "../../../utility";
import { apiFunction } from "../Axios/functions";
import { CreateEditFormStoryModal } from "../Modals/index";
export default {
  name: "story-table",
  components: { CreateEditFormStoryModal },
  props: {
    columns: Array,
    adminId: String,
    accountId: String,
    allScenario: Array,
    data: Array,
    userIconList: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    currentNumber: {
      type: Number,
      default: 0,
    },
    trigger: Object,
  },
  data() {
    return {
      accountType: "",
      formScenarioId: "",
      jwtToken: "",
      copyFormScenarioItem: {
        formscenario: {},
        nodes: [],
      },
      modalData: {
        formScenarioName: "",
        trigger: "",
        keywords: [],
        nodes: [],
        modalBtn: this.$t("__edit"),
        modalSuccessMsg: this.$t(
          "__Anewconversationhasbeensuccessfullyestablished"
        ),
      },
      editId: "",
      componentKey: 0,
      isFormScenarioSortAsc: true,
      // テーブルのソート状態（none, asc, desc）
      formScenarioNameColumnSortState: 'none',
    };
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    // Prepare page content
    async loadData() {
      try {
        this.accountType = this.getAccountType();
        let user = await this.$Amplify.Auth.currentAuthenticatedUser();
        this.jwtToken = user.getSignInUserSession().getIdToken().jwtToken;
      } catch (e) {
        this.$fire({
          title: this.$t('__authExpired'),
          text: this.$t('__pleaseLogin'),
          type: "error"
        }).then(() => {
          this.$Amplify.Auth.signOut();
          localStorage.clear();
          this.$router.push("/login");
        });
      }
    },
    // Get account type from _token
    getAccountType() {
      let decrypt = this.$aes.decrypt(localStorage._token).split(",");
      let accountType = decrypt[3];
      return accountType;
    },
    // Tirgger type: follow, keyword, error, ""
    triggerValue(item) {
      if (item == "liffScenario") {
        return "<span>" + this.$t("__LiffScenario") + "</span>";
      }
      //加入表單篩選
      if (item == "formFilter") {
        return "<span>" + this.$t("__FormFilter") + "</span>";
      }
    },
    // Show keywords when click 關鍵字
    showKeyords(trigger, keywords) {
      if (trigger == "keyword") {
        this.$alert(`${this.$t('__keywords')}: ${keywords}`);
      }
    },
    // Example: 2020-06-30 15:03
    toFrontendTimeFormat(dateTime) {
      return this.$dateTime.toFrontEndTimeFormat(dateTime);
    },
    // Edit formscenario
    editStory(item) {
      this.forceRerender();
      this.editId = item.formscenario.formScenarioId;
      this.modalData.nodes = item.nodes;
      this.modalData.formScenarioName = item.formscenario.formScenarioName;
      this.modalData.trigger = item.formscenario.trigger;
      this.modalData.keywords = Utility.deepCopy(item.formscenario.keywords);
      this.modalData.modalBtn = this.$t("__edit");
      this.modalData.modalSuccessMsg = this.$t("__Editsuccessfullyaccessed");
    },
    // Re render modal component
    forceRerender() {
      this.componentKey += 1;
    },
    // Init new name
    // Example C00001
    getNewformScenarioName() {
      // シナリオ名のリストを取得
      const formScenarioNames = this.data.map(e => e.formscenario.formScenarioName);
      // 連番部分の初期値はシナリオ総数 + 1
      let consecutiveNumber = formScenarioNames.length + 1;
      while (formScenarioNames.includes(`C${consecutiveNumber.toString().padStart(5, "0")}`)) {
        // 生成したシナリオ名が既に存在する場合は、連番部分をインクリメント
        consecutiveNumber++;
      }
      return "C" + consecutiveNumber.toString().padStart(5, "0");
    },
    // Add formscenario
    createStory() {
      this.forceRerender();
      this.editId = "";
      this.modalData.formScenarioName = this.getNewformScenarioName();
      this.modalData.trigger = "";
      this.modalData.nodes = [];
      this.modalData.keywords = [];
      this.modalData.modalBtn = this.$t("__setup");
      this.modalData.modalSuccessMsg = this.$t(
        "__Anewconversationhasbeensuccessfullyestablished"
      );
    },
    // Copy formscenario
    copyFormScenario(target) {
      this.copyFormScenarioItem.formscenario = {
        keywords: target.formscenario.keywords,
        formScenarioName: target.formscenario.formScenarioName + "(copy)",
        trigger: target.formscenario.trigger,
      };
      this.copyFormScenarioItem.nodes = Utility.deepCopy(target.nodes);
      // Follow & Error are not allow to copy
      if (
        target.formscenario.trigger == "follow" ||
        target.formscenario.trigger == "error"
      ) {
        return this.$fire({
          title: this.$t("__Addfailed"),
          text: this.$t("__Theerrormessageoruserjoinmessagealreadyexists"),
          type: "error",
        });
      }

      this.$fire({
        title: this.$t("__Copycurrenttarget"),
        text: this.$t("__Createacopyofthisconversationwiththenode"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("__Add"),
        cancelButtonText: this.$t("__cancel"),
      }).then((result) => {
        if (result.value) {
          // Update nodeId
          var nodeIdMap = {};
          this.copyFormScenarioItem.nodes.forEach((node, index) => {
            const newNodeId = Utility.generateNewId(this.$dateTime.getDateTime(), index);
            nodeIdMap[node.nodeId] = newNodeId;
            node.nodeId = newNodeId;
          });
          // Update nextNode Id
          this.copyFormScenarioItem.nodes.forEach((node, index) => {
            if (node.nextNode != "") {
              const oldNodeId = node.nextNode;
              node.nextNode = nodeIdMap[oldNodeId] ? nodeIdMap[oldNodeId] : ""
            }
          });

          let formData = {
            adminId: this.adminId,
            accountId: this.accountId,
            formscenario: this.copyFormScenarioItem.formscenario,
            nodes: this.copyFormScenarioItem.nodes,
          };

          apiFunction.saveFormScenario(formData, this.jwtToken).then((data) => {
            if (data) {
              this.$fire({
                title: this.$t("__addedsuccessfully"),
                text: this.$t("__Anewcopyhasbeencreated"),
                type: "success",
                timer: 1500,
              }).then((e) => {
                this.$router.go();
              });
            } else {
              this.$fire({
                title: this.$t("__Addfailed"),
                text: this.$t("__oopsSomethingwentwrong"),
                type: "error",
              });
            }
          });
        }
      });
    },
    // Delete formscenario
    deleteFormScenario(formScenarioId) {
      this.formScenarioId = formScenarioId;
      this.$fire({
        title: this.$t("__Areyousureyouwanttodeleteit"),
        text: this.$t("__Thesystemwillnotbeabletoretrieveyourdata"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("__YesIwanttodelete"),
        cancelButtonText: this.$t("__cancel"),
      }).then((result) => {
        if (result.value) {
          let formData = {
            adminId: this.adminId,
            accountId: this.accountId,
            formScenarioId: this.formScenarioId,
          };

          apiFunction.deleteFormScenario(formData, this.jwtToken).then((data) => {
            if (data) {
              this.$fire({
                title: this.$t("__successfullydeleted"),
                text: this.$t("__Yourdatahasbeensuccessfullydeleted"),
                type: "success",
                timer: 1500,
              }).then((e) => {
                this.$router.go();
              });
            } else {
              this.$fire({
                title: this.$t("__failedtodelete"),
                text: this.$t("__oopsSomethingwentwrong"),
                type: "error",
              });
            }
          });
        }
      });
    },
    getSortOrderLabel(order) {
      if (order == 'none') return '';
      return order == 'asc' ? '▲' : '▼';
    },
    onClickformScenarioNameColumnHeader() {
      this.formScenarioNameColumnSortState = (this.formScenarioNameColumnSortState == 'asc' ? 'desc' : 'asc');
      this.sortTableByformScenarioNameColumn();
    },
    sortTableByformScenarioNameColumn() {
      const ascFunc = (a, b) => {
        if (a.formscenario.formScenarioName < b.formscenario.formScenarioName) return -1;
        if (a.formscenario.formScenarioName > b.formscenario.formScenarioName) return 1;
        return 0;
      }
      const descFunc = (a, b) => {
        if (a.formscenario.formScenarioName > b.formscenario.formScenarioName) return -1;
        if (a.formscenario.formScenarioName < b.formscenario.formScenarioName) return 1;
        return 0;
      }
      this.data.sort(this.formScenarioNameColumnSortState == 'asc' ? ascFunc : descFunc);
    },
    onUserIconChanged(item) {
      let formData = {
        adminId: this.adminId,
        accountId: this.accountId,
        formscenario: item.formscenario,
        nodes: item.nodes,
      };

      apiFunction.saveFormScenario(formData, this.jwtToken).then((data) => {
        if (data) {
          this.$fire({
            title: this.$t("__updatecompleted"),
            text: this.$t("__Editsuccessfullyaccessed"),
            type: "success",
            timer: 1500,
          })
        } else {
          this.$fire({
            title: this.$t("__Addfailed"),
            text: this.$t("__oopsSomethingwentwrong"),
            type: "error",
          });
        }
      });
    }
  },
};
</script>
<style>
td a:not(.md-button) {
  color: #212529 !important;
}
</style>
